import { useQuery, UseQueryResult } from "@tanstack/react-query";
import config from "../config.json";
import { createAxiosInstance } from "./ServicesHelpers";

const axiosInstance = createAxiosInstance(config.HOST_MANAGEMENT_API_BASE_URL);

export async function fetchWhiteListedIps(): Promise<string[]> {
  try {
    const response = await axiosInstance.get("/client-access/allowed-ips");
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while getting the whitelisted IPs."
    );
  }
}

export const useWhiteListedIpsQuery = (): UseQueryResult<string[], Error> => {
  return useQuery({
    queryKey: ["whitelisted-ips"],
    queryFn: () => fetchWhiteListedIps(),
  });
};
